import React, { useState, useEffect } from "react";
import { Col, Row, Tabs } from "antd";
import RegistrationSchoolRequest from "../registration-school-scholarships/RegistrationSchoolRequest";
import RegistrationUniversityRequest from "../registration-university-scholarships/RegistrationUniversityRequest";
import Selects from "../../../../biblio/Selects/Selects";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getBeneficiaryDetails } from "../../../../apis/actions/recipient.actions";
import CustomConfigProvider from "../../ProfileHeader";
const RegistrationRequest = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { beneficiaryDetails } = useSelector(
    (state: RootState) => state?.recipient
  );

  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [state, setState] = useState({
    year: "",
    month: "",
  });

  useEffect(() => {
    dispatch(getBeneficiaryDetails());
  }, [dispatch]);

  const filterOrphans =
    beneficiaryDetails?.person_ids?.filter(
      (person: any) =>
        person?.beneficiary_type === "son" ||
        person?.beneficiary_type === "daughter"
    ) || [];

  const handleSelectChange = (value: any) => {
    if (value) {
      setSelectedFilter(
        filterOrphans.find((person: any) => person.name === value.label)?.id ||
          null
      );
    } else {
      setSelectedFilter(null);
    }
  };

  const tabsData = [
    {
      key: "university",
      label: "المنح الجامعية",
      content: (
        <RegistrationUniversityRequest
          selectedFilter={selectedFilter}
          filterOrphans={filterOrphans}
          state={state}
        />
      ),
    },
    {
      key: "school",
      label: "المنح المدرسية",
      content: (
        <RegistrationSchoolRequest
          selectedFilter={selectedFilter}
          filterOrphans={filterOrphans}
          state={state}
        />
      ),
    },
  ];

  return (
    <>
      <CustomConfigProvider
        title="التسجيل على المنح"
        withdateFilter={true}
        filterState={state}
        setState={(values) => setState(values)}
      >
        <Selects
          options={filterOrphans}
          selectPlaceholder="المستفيد"
          onChange={handleSelectChange}
          allowClear={true}
          className="takaful--service-select takaful--request-select"
          popupClassName="takaful--service-select-dropdown"
        />
      </CustomConfigProvider>

      <Tabs
        defaultActiveKey="university"
        className="takaful--content-profile-tab takaful--registration"
        items={tabsData.map(({ key, label, content }) => ({
          key,
          label: (
            <Row style={{ width: "100%" }}>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <div className="tab-label">
                  <span className="tab-label-text">{label}</span>
                </div>
              </Col>
            </Row>
          ),
          children: (
            <div
              style={{
                border: "3px solid #EFEFEF",
                padding: "2rem",
                borderRadius: "25px",
                direction: "ltr",
              }}
            >
              {content}
            </div>
          ),
        }))}
      />
    </>
  );
};

export default RegistrationRequest;
